const setHttpRequestId = (axiosInstance, httpRequestId) => {
  if (httpRequestId)
    axiosInstance.defaults.headers.common['X-Request-Id'] = httpRequestId
}

export default setHttpRequestId
